import { HeNotification } from '../../../common/components/HeNotification/HeNotification';
import { SmallText, HeadlineText } from './FluvaxBanners.styles';

export const FluvaxBannerOver65 = () => (
  <HeNotification kind="info">
    <HeadlineText>
      If you are aged over 65, an enhanced flu vaccine is available to you under the National
      Immunisation Program.
    </HeadlineText>
    <SmallText>
      Please note that in SA, NT, NSW, TAS, and QLD, the enhanced vaccine is only available at GP
      clinics. In ACT, VIC, and WA, the enhanced vaccine is available at GP clinics and selected
      pharmacies.
    </SmallText>
  </HeNotification>
);
